module.exports = __webpack_public_path__ + "static/media/1.87bd6d04.jpg";